/**
 * useImportRuns Hook
 *
 * Fetches import run history for the current clinic.
 */

import { useState, useCallback, useEffect } from 'react';
import { api } from '../lib/api';

export const useImportRuns = () => {
  const [runs, setRuns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRuns = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await api.getImportRuns();
      setRuns(data.runs || []);
    } catch (err) {
      console.error('Failed to fetch import runs:', err);
      setError(err);
      setRuns([]);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchRuns();
  }, [fetchRuns]);

  return { runs, loading, error, refetch: fetchRuns };
};
